/**
 * NewlineText Component
 * 
 * React component that renders text with proper line break handling.
 * Splits text on newline characters and renders each line with proper spacing.
 * 
 * @param {Object} props - Component props
 * @param {string} props.text - The text to render with line breaks
 * @returns {JSX.Element} The text component with line breaks
 */
export function NewlineText({ text }) {
    if(!text) return <>{text}</>;
    const newText = text.split('\n').map((str, index, array) => 
        index === array.length - 1 ? str : <>
            {str}
            <br />
        </>
    );

    return <>{newText}</>;
  };

/**
 * Converts the first letter of a string to uppercase.
 * 
 * @param {string} string - The string to capitalize
 * @returns {string} The string with the first letter capitalized
 */
export function uppercaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};